import { IPostContentExpertBlocks } from '../../types/postContentExpertBlocks';
import {
  EPostContentExpertBlockActionType,
  TPostContentExpertBlockActions,
} from '../../actions/postContentExpertBlock';
import { ERequestStatus } from '../../types/requestStatus';

export const defaultState: IPostContentExpertBlocks = {
  items: [],
};

export const postContentExpertBlocksReducer = (state = defaultState, action: TPostContentExpertBlockActions) => {
  switch (action.type) {
    case EPostContentExpertBlockActionType.Set: {
      return {
        ...state,
        items: [...state.items, { ...action.payload, status: ERequestStatus.Succeed }],
      };
    }

    case EPostContentExpertBlockActionType.Reset:
      return defaultState;

    default:
      return state;
  }
};
